'use client';
import { Dropdown } from './dropdown.js';
import { DropdownButton } from './dropdown-button.js';
import { DropdownHeading } from './dropdown-heading.js';
import { DropdownItem } from './dropdown-item.js';
import { DropdownList } from './dropdown-list.js';
import { DropdownTrigger } from './dropdown-trigger.js';
import { DropdownTriggerContext } from './dropdown-trigger-context.js';

/**
 * Dropdown component, used to display a list of options.
 *
 * @example with TriggerContext
 * <Dropdown.TriggerContext>
 *   <Dropdown.Trigger>Dropdown trigger</Dropdown.Trigger>
 *   <Dropdown placement='bottom-end'>
 *     <Dropdown.Heading>Dropdown</Dropdown.Heading>
 *     <Dropdown.List>
 *       <Dropdown.Item>
 *         <Dropdown.Button>Option</Dropdown.Button>
 *       </Dropdown.Item>
 *     </Dropdown.List>
 *   </Dropdown>
 * </Dropdown.TriggerContext>
 *
 * @example without TriggerContext
 * <Button popovertarget="my-dropdown">Trigger</Button>
 * <Dropdown id="my-dropdown">
 *   <Dropdown.Heading>Heading</Dropdown.Heading>
 *   <Dropdown.List>
 *     <Dropdown.Item>
 *       <Dropdown.Button>Item</Dropdown.Button>
 *     </Dropdown.Item>
 *   </Dropdown.List>
 * </Dropdown>
 */
const DropdownComponent = Object.assign(Dropdown, {
    TriggerContext: DropdownTriggerContext,
    Heading: DropdownHeading,
    List: DropdownList,
    Item: DropdownItem,
    Button: DropdownButton,
    Trigger: DropdownTrigger,
});
DropdownComponent.TriggerContext.displayName = 'Dropdown.TriggerContext';
DropdownComponent.List.displayName = 'Dropdown.List';
DropdownComponent.Heading.displayName = 'Dropdown.Heading';
DropdownComponent.Item.displayName = 'Dropdown.Item';
DropdownComponent.Button.displayName = 'Dropdown.Button';
DropdownComponent.Trigger.displayName = 'Dropdown.Trigger';

export { DropdownComponent as Dropdown, DropdownButton, DropdownHeading, DropdownItem, DropdownList, DropdownTrigger, DropdownTriggerContext };
